(function(angular){
	'use strict';
	
	var planStrategyObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			planName: '<',
			lightTheme: '@?'
		},
		controller: [
			'$filter', 
			'STATIC_BASE_PATH',
			PlanStrategyFunction
		],
		controllerAs: 'planStrategy'
	};
	
	angular
		.module('viewPlanModule')
		.component('planStrategy', planStrategyObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/ria/view-plan/plan-strategy.html';
	}
	
	function PlanStrategyFunction(
		$filter,
		STATIC_BASE_PATH){
		var planStrategy = this;
		var pointOptions;

		planStrategy.$onInit = function() {
			pointOptions = {
				'Long-Term Growth': [{
						text: {
							firstWord: 'Acquire',
							headline: 'assets with a high potential to grow in value',
							content: 'To capture maximum growth potential in real estate, the key is to buy ahead of major demographic or cultural shifts, understand emerging neighborhood growth, or recognize untapped property&nbsp;potential.'
						},
						media: {
							headline: 'Walk through a new renovation project with our team',
							type: 'video',
							src: 'https://www.youtube.com/embed/K9i_uPZnhok?rel=0&showinfo=0'
						}
					},{
						text: {
							firstWord: 'Improve',
							headline: 'the real estate to increase the sale price',
							content: 'In the real economy, we can create value from hard work. Most classically in real estate, we produce value through intelligent zoning, development and leasing – building new urban housing, renovating run-down apartments, and renting vacant buildings.'
						},
						media: {
							type: 'img',
							src: STATIC_BASE_PATH + '/images/marketing/ria/construction-site-example.jpg'
						}
					},{
						text: {
							firstWord: 'Realize',
							headline: 'returns mostly at the end when we sell the property',
							content: 'There is normally greater demand for complete real estate developments. There are many more potential homebuyers for a renovated home than a rundown shack, and more renters for new luxury apartments near a metro than for the previously vacant land.'
						},
						media: {
							type: 'img',
							src: STATIC_BASE_PATH + '/images/marketing/ria/growth-strategy-realize-returns.png'
						}
					}],
				'Supplemental Income': [{
						text: {
							firstWord: 'Acquire',
							headline: 'assets that generate consistent cash flow',
							content: 'We invest primarily in assets that generate predictable returns from the moment we make the investment. This could mean lending to the developer of a new property, or buying an existing building with tenants in place.'
						},
						media: {
							headline: 'New apartment community in Springfield, MO',
							type: 'img',
							src: STATIC_BASE_PATH + '/images/marketing/ria/aspen-heights-springfield.jpg',
							callout: {
								amount: 11,
								label: 'Annual cash flow',
								icon: 'cash-flow'
							}
						}
					},{
						text: {
							firstWord: 'Improve',
							headline: 'the real estate to increase margin of safety',
							content: 'To maintain and grow a high-income stream, we prefer to invest in a business plan that improves the value of the property. Investors can more predictably capture above-market returns by increasing the value of a building.'
						},
						media: {
							headline: 'Before and after renovations on apartments in Jacksonville, FL',
							type: 'slider',
							src: STATIC_BASE_PATH + '/images/marketing/ria/reserve-at-mandarin-before.jpg',
							srcTwo: STATIC_BASE_PATH + '/images/marketing/ria/reserve-at-mandarin-after.jpg',
							callout: {
								amount: 24,
								label: 'Increase in rent',
								icon: 'increase'
							}
						}
					},{
						text: {
							firstWord: 'Realize',
							headline: 'returns over time via rent or interest payments',
							content: 'Unlike in a growth strategy, where returns are typically “back-ended” when the property is sold, investors in an income strategy can look forward to earning consistent distributions over time as we collect rent or interest payments.'
						},
						media: {
							type: 'cash-flow-graphic',
							src: STATIC_BASE_PATH + '/images/marketing/ria/income-strategy-realize-returns-3.png',
							srcTwo: STATIC_BASE_PATH + '/images/marketing/ria/cash-flow-arrows-2.svg'
						}
					}
				]
			};

			planStrategy.points = pointOptions[planStrategy.planName];
		};

		planStrategy.$onChanges = function(changeObj) {
			if(planStrategy.planName && changeObj.planName && pointOptions) {
				planStrategy.points = pointOptions[changeObj.planName.currentValue];
			}
		};
	}
})(window.angular);